module.exports = __webpack_public_path__ + "img/album03_10.4f39d96f.jpg";